var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath50Dark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 514,
    viewBox: "0 0 580 514",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.993 -0.000427246C223.752 108.601 122.706 198.16 0 256.968C122.706 315.775 223.752 405.334 289.993 513.936C356.234 405.334 457.294 315.775 580 256.968C457.294 198.16 356.234 108.601 289.993 -0.000427246Z",
    fill: "url(#paint0_linear_1111_1869)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1111_1869",
    x1: 229.5,
    y1: 411.5,
    x2: 345,
    y2: -147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208333,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023783",
    stopOpacity: 0.38
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath50Dark);
export default __webpack_public_path__ + "static/media/path50Dark.545da85b79af51a9bde5a04e339dd9d2.svg";
export { ForwardRef as ReactComponent };